import { LinearProgress, Typography } from '@material-ui/core';
import React from 'react';

import { BoxCenter } from '~/src/dash/views/box-align-center-view';

export interface ILoadingProps {
  active: boolean;
  containerStyles?: any;
  innerStyles?: any;
  textStyles?: any;
  text?: string;
}

export function LoadingView({
  active,
  containerStyles,
  innerStyles,
  textStyles,
  text,
}: ILoadingProps) {
  return (
    <BoxCenter
      containerStyles={{
        transform: 'all 1s',
        opacity: active ? 1 : 0,
        ...containerStyles,
      }}
      innerStyles={innerStyles}
    >
      <Typography variant='h4' style={{ marginBottom: '1rem', ...textStyles }}>
        {text || 'Loading'}
      </Typography>
      <div style={{ padding: '2rem 3rem ' }}>
        <LinearProgress />
      </div>
    </BoxCenter>
  );
}
